// CAD-driven specs (inches). Keep this as the single source of truth.
export const CAD_SPECS = {
  product: 'Azenco R-Blade 5594-004',
  units: 'in',

  limits: {
    maxWidth: 192,    // 16'-0"
    maxLength: 276,   // 23'-0"
    minWidth: 72,
    minLength: 72,
    minHeight: 84,
    maxHeight: 144,
  },

  structure: {
    postSize: 6.5,
    postWall: 1 + 5 / 32,
    mainBeamHeight: 14,
    mainBeamFlange: 5.75,
    seamGap: 1 / 6,
    fasciaHeight: 14,
  },

  gutter: {
    height: 4,            // 4" tall U-channel
    width: 5.5,           // 5.5" wide
    flangeThick: 0.5,     // wall thickness
    bottomThick: 0.375,   // gutter floor
    innerLipH: 2.5,       // inner flange height (louver rest point)
  },

  blade: {
    chord: 9.5,
    height: 4.625,
    depth: 3.625,
    thickness: 2.125,
    maxAngle: 110,       // max open angle in degrees (from closed)
  },

  post: {
    maxSpanStandard: 23 * 12,    // 23' max span without structural header
    maxSpanWithHeader: 30 * 12,  // 30' max span with structural header beam
    maxCantilever: 36,           // 3' max cantilever inset from corner
    minPostsPerSpan: 2,          // 2 posts per span minimum (at each end)
  },

  connection: {
    plate: 11.375,
    edgeHeaderHeight: 3.125,
    edgeHeaderDepth: 0.75,
    cornerAngleSize: 3.125,
    cornerAngleThickness: 0.5,
    postCoverWidth: 3.375,
    postCoverDepth: 1.0,
  },

  accessory: {
    fanBeam: 4.0,
    recessedLightOffsetFromBeamEnd: 25,
    maxRecessedPerBay: 2,
    maxFansPerBay: 1,
  },

  load: {
    windMph: {
      closed: 110,
      partial: 75,
      open: 50,
    },
    snowLbsPerSqFt: {
      fresh1in: 1,
      fresh6in: 3,
      packed12in: 15,
      ice6in: 30,
    },
  },

  zoneRules: {
    maxZones: 6,
    layouts: ['linear_length', 'linear_width', 'L_shape', 'rectangle', 'square'],
    connections: ['length_to_length', 'width_to_width', 'mixed'],
  },
};

// inches -> meters helper
export const IN_TO_M = 0.0254;
export const inToM = (v) => v * IN_TO_M;
